module.exports = __webpack_public_path__ + "media/images/grid_preview_portrait-7e7c62e82e6c2de14a2b0e692e53cd1b.png";